import { Table, Select, Popconfirm, Space } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  deleteOrderAction,
  InfoUserOrderAction,
} from "../../../appRedux/action/OrderAction";
import moment from "moment";
import ModalItem from "./ModalItem";
const { Option } = Select;
const TableRegister = () => {
  const [statusModal, setStatusModal] = useState(false);
  const [dataModal, setDataModal] = useState({});
  const OrderList = useSelector((items) => items.userOrder.userOrder);
  const loading = useSelector((items) => items.userOrder.isLoading);

  // console.log(OrderList);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(InfoUserOrderAction());
  }, []);

  const handleDelete = async (value) => {
    // console.log(value);
    const data = {
      order_id: value,
    };
    await dispatch(deleteOrderAction(data));
  };

  const handleEdit = (value) => {
    const temp = OrderList.find((x) => x._id === value.toString());

    setDataModal(temp);
    setStatusModal(true);
  };

  const handleClose = (value) => {
    setStatusModal(value);
    setDataModal({});
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "stt",
      key: "stt",
      align: "center",
    },
    {
      title: "Người tiêm",
      dataIndex: "name",
      key: "name",
      align: "center",
      render: (value) => (
        <span style={{ color: "#3898ec", fontSize: "14px" }}>{value}</span>
      ),
    },

    {
      title: "Phòng bệnh tương ứng",
      dataIndex: "pathogens",
      key: "pathogens",
      align: "center",
    },
    {
      title: "Phòng tiêm ĐK",
      dataIndex: "location_medical",
      key: "location_medical",
      align: "center",
    },
    {
      title: "Ngày tiêm đăng ký",
      dataIndex: "date_register",
      key: "date_register",
      align: "center",
    },
    {
      title: "Ngày tiêm xác nhận",
      dataIndex: "date_verify",
      key: "date_verify",
      align: "center",
    },

    {
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (value) => {
        if (+value === 0) return "Chờ thanh toán";
        if (+value === 1) return "Chờ xác nhận ngày tiêm";
        if (+value === 2) return "Đăng ký thành công";
        if (+value === 3) return "Đã tiêm";
        if (+value === 4) return "Đã hủy";
      },
    },
    {
      title: "Tùy chọn",

      align: "center",
      width: "10%",
      render: (text, record) => (
        <>
          <Space size="middle">
            <Popconfirm
              title="Bạn có muốn sửa？"
              onConfirm={() => {
                handleEdit(record.key);
              }}
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              disabled={
                record.status === 0 || record.status === 1 ? false : true
              }
            >
              <a
                href=""
                disabled={
                  record.status === 0 || record.status === 1 ? false : true
                }
              >
                {" "}
                <span>Chi tiết </span>
              </a>
            </Popconfirm>
          </Space>
        </>
      ),
    },
    {
      title: "Tùy chọn",

      align: "center",
      width: "10%",
      render: (text, record) => (
        <>
          <Space size="middle">
            <Popconfirm
              title="Bạn có muốn hủy？"
              onConfirm={() => {
                handleDelete(record.key);
              }}
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              disabled={
                record.status === 0 || record.status === 1 ? false : true
              }
            >
              <a
                href=""
                disabled={
                  record.status === 0 || record.status === 1 ? false : true
                }
              >
                {" "}
                <span>Hủy đăng kí</span>
              </a>
            </Popconfirm>
          </Space>
        </>
      ),
    },
  ];

  const data =
    OrderList && OrderList?.length > 0
      ? OrderList.map((item, index) => ({
          stt: index + 1,
          key: item._id,

          name: item.name || "",
          pathogens: item.pathogen || "",
          location_medical: item?.location?.name || "",
          date_register: item.booking_date_timestamp
            ? moment.unix(item.booking_date_timestamp).format("DD/MM/YYYY")
            : "",
          date_verify:
            item.confirm_date_timestamp === 0
              ? "-"
              : moment(item.confirm_date).format("DD/MM/YYYY"),

          status: item.status || 0,
        }))
      : null;
  // console.log(data);
  return (
    <>
      <div className="TableRegister container-fluid">
        <div className="row">
          <div className="content_table col-12 p-0  mb-3">
            <Table
              loading={loading}
              size="small"
              bordered
              columns={columns}
              dataSource={data}
              scroll={{ x: 770 }}
            />
          </div>
        </div>

        <ModalItem
          handleClose={handleClose}
          data={dataModal}
          invisibleModal={statusModal}
        />
      </div>
    </>
  );
};

export default TableRegister;
